const appManagement = {
    appMList: [],
    loadingAppM: true
};

export default appManagement;
